import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import QualitySummary from 'containers/Dashboard/Quality/QualitySummary';
import QualityDetails from 'containers/Dashboard/Quality/QualityCards';
import QualityInquiry from 'containers/Dashboard/Quality/QualityInquiry';
import SharedCanvas from 'containers/Dashboard/components/SharedCanvas';
import { useDashboardContext } from 'containers/Dashboard/context/DashboardContext';

const DETAIL_CONFIG_KEYS: Record<string, 'jobNum' | 'partNum' | 'empID' | 'resourceID'> = {
  summary_jobdetails: 'jobNum',
  summary_partdetails: 'partNum',
  summary_employeedetails: 'empID',
  summary_machinedetails: 'resourceID',
};

function QualityCanvas() {
  const { canvasId } = Route.useParams();
  const { authtoken, selectedDate, qualityData } = useDashboardContext();

  if (canvasId === 'summary') {
    return (
      <QualitySummary
        authtoken={authtoken}
        selectedDate={selectedDate}
        qualityData={qualityData}
      />
    );
  }
  if (canvasId in DETAIL_CONFIG_KEYS) {
    return (
      <QualityDetails
        authtoken={authtoken}
        selectedDate={selectedDate}
        qualityData={qualityData}
        configKey={DETAIL_CONFIG_KEYS[canvasId]}
      />
    );
  }
  if (canvasId === 'inquiry') {
    return <QualityInquiry authtoken={authtoken} selectedDate={selectedDate} />;
  }
  return <SharedCanvas dashboard="quality" canvasId={canvasId} />;
}

export const Route = createFileRoute(
  '/_authenticated/dashboard/quality/$canvasId'
)({
  component: QualityCanvas,
});
